
















































import { Component, Mixins, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { RootStoreHelper } from '../../core/mixins';
import { error } from 'highcharts';
@Component({
    components: {
        Loading
    }
})
export default class LDialogOld extends Mixins(RootStoreHelper) {
    value: any = [];
    selected: any = null;
    @Prop() pendingRequest: boolean;
    @Prop() errorResponse: any;
    @Prop() successPost: boolean | null;
    @Prop({default: ''}) customClass: string;
    @Prop() msg: string;

    get isError() {
        if (this.successPost == false) {
            return true;
        } else {
            return false;
        }
    }

    get visibilityMoreInfo() {
        if (this.isError && Object.values(this.errorResponse).length !== 0) {
            return true;
        } else {
            return false;
        }
    }

    @Emit()
    closeModal() {}

    mounted() {}
}
